import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Row } from 'react-bootstrap'
import types from '../../types/types';

// Component to show error messages to the user in any page.
// If recive a message diferent than "null", its shows to the user.
// Message: message attribute is null by default in order to avoid to show to the user always an error disclaimer.
// useFormSetValue: "setValue" function retrived from useForm hook. As convection, we use an standarized attribute calls "backendError" along whole frontend code
//                  and inside this componente, we remove message if user has click con "X" button. 
export const ErrorMessage = ({message = null, useFormSetValue = null}) => {

    // Load de message in state variable in order to handle component visibility.
    const [localMessage, setLocalMessage] = useState(message);

    // Function to remove user message executing "setValue" encapsulated in "useFromSetValue" function recived has parameter.
    const removeError = () => {
        useFormSetValue(types.ERROR, null);
        setLocalMessage("");
    }

    // Its responsability is to renderize again after "removeError" function remove "backendError" when user press the "X" button.
    useEffect(() => {
        setLocalMessage(message);
    }, [message])
    
    return (localMessage)?(
            
                <Container fluid className="px-0">
                    <Alert className="mb-0 backgrou bg-primary text-white">
                        <Row>
                            <Col lg="11">
                                <i className="material-icons">info</i> {localMessage}
                            </Col>
                            <Col lg="1">
                                {(useFormSetValue)?( // If recive "useFormSetValue" function, we must show a "X" button to let the user close de message alert.
                                    // autoFocus attribute is to bring the user to top when the user is at the bottom of the page
                                    <Button autoFocus onClick={ () => removeError()} className='p-0 m-0' > 
                                        <i className='material-icons md-18'>close</i>
                                    </Button>
                                 ):("")}
                            </Col>
                        </Row>
                    </Alert>
                </Container>
            ):("");
}

export default ErrorMessage;
